module.exports = __webpack_public_path__ + "static/Net_Worth-265f9f1ebc125e3c82b8e43a42235b52.png";